module.exports = "<div ui-view></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/atc/templates/atc-main.html
// module id = 3426
// module chunks = 0